export default __webpack_public_path__ + "static/media/warning--gate--g2.7393d775.png";